export default {"src":"/_next/static/media/hide.3dd48a0f.svg","height":17,"width":24};